export enum RoleEnum {
  USER = 'user',
  AGENT = 'agent',
  PARTNER = 'partner',
  SALESPERSON = 'salesperson',
  ADMIN = 'admin',
}
